import styled, { css, keyframes, withTheme } from 'styled-components';
import DownloadingArrow from '../../assets/images/downloading-arrow.svg';
import DownloadingSpinner from '../../assets/images/downloading-spinner.svg';
import ListItemIcon from './ListItemIcon';

const animation = keyframes`
    0% {
        transform: scale(1) rotate(0deg);
    }
    100% {
        transform: scale(1) rotate(360deg);
    }
`;
const animationRule = css`
  ${animation} 2s infinite linear;
`;

const SeperatedDownloadingDataIcon = styled(ListItemIcon)`
  border-left: 1px solid ${(props) => props.theme.palette.common.backgroundDark};
  background: none;
  position: relative;
  &:before {
    position: absolute;
    right: -5px;
    top: -5px;
    background: url(\"${DownloadingArrow}\") no-repeat center center;
    content: '';
    width: 34px;
    height: 34px;
  }
  &:after {
    position: absolute;
    right: -5px;
    top: -5px;
    background: url(\"${DownloadingSpinner}\") no-repeat center center;
    animation: ${animationRule};
    content: '';
    width: 34px;
    height: 34px;
  }
`;

export default withTheme(SeperatedDownloadingDataIcon);
